import moment from 'moment';

import type { ISearchState, NationalURLParams, RentCarsURLParams } from '../types';

type SearchData = { [key: string]: string };

const mergeDateAndTime = (dates: SearchData, time: SearchData) =>
  Object.entries(dates).reduce(
    (acc, [key, date]) => {
      const [hours, minutes] = time[key].split(':').map(Number);
      const parsedDate = new Date(`${date.split('T')[0]}T00:00:00`);
      parsedDate.setHours(hours, minutes);

      const formattedDate = moment(parsedDate).toISOString(true).split('.')[0];

      return { ...acc, [key]: formattedDate };
    },
    { pickup: '', dropoff: '' },
  );

export const buildNationalURL = (
  location: ISearchState['location'],
  dates: ISearchState['dates'],
  time: ISearchState['time'],
) => {
  const mergedDatesWithTime = mergeDateAndTime(dates as SearchData, time as SearchData);
  const { pickup, dropoff } = location;

  const payload: NationalURLParams = {
    pickUpCode: pickup?.code.toString() as string,
    pickUpDate: mergedDatesWithTime.pickup,
    returnCode: dropoff?.code.toString() as string,
    returnDate: mergedDatesWithTime.dropoff,
  };

  return new URLSearchParams(payload).toString();
};

export const buildInternationalURL = (
  location: ISearchState['location'],
  dates: ISearchState['dates'],
  time: ISearchState['time'],
) => {
  const mergedDatesWithTime = mergeDateAndTime(dates as SearchData, time as SearchData);

  const payload: RentCarsURLParams = {
    agenciaDevolucao: (location.dropoff?.code ?? 0).toString(),
    agenciaRetirada: (location.pickup?.code ?? 0).toString(),
    dataHoraDevolucao: mergedDatesWithTime.dropoff,
    dataHoraRetirada: mergedDatesWithTime.pickup,
  };

  return new URLSearchParams(payload).toString();
};
